import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from 'mailup-web-components'

import {
  modalSaveSegmentCancelCallback,
  modalSaveSegmentChangeCallback,
  modalSaveSegmentConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalSaveSegment'
import { modalSaveSegmentState } from 'Pages/RecipientsList/recoil/state/modals'

const ModalSaveSegment: FC = () => {
  const intl = useIntl()

  const { show, name, nameIsDirty } = useRecoilValue(modalSaveSegmentState)

  const handleCancel = useRecoilCallback(modalSaveSegmentCancelCallback, [])
  const handleConfirm = useRecoilCallback(modalSaveSegmentConfirmCallback, [])

  const change = useRecoilCallback(modalSaveSegmentChangeCallback, [])

  const handleChangeName = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    void change(value)
  }

  const canSave = name.trim().length > 0

  const showFeedback = nameIsDirty && !canSave

  return (
    <Modal
      show={show}
      onClose={handleCancel}
      data-mu-test="modal-save-segment"
      closeOnOverlayClick
      showClose
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalSaveSegmentTitle',
        })}
      />

      <ModalBody>
        <FormElement
          variant={showFeedback ? 'danger' : undefined}
          feedback={
            showFeedback
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : undefined
          }
        >
          <InputText
            value={name}
            onChange={handleChangeName}
            variant={showFeedback ? INPUT_TEXT_VARIANT_DANGER : undefined}
            placeholder={intl.formatMessage({
              id: 'Load.RecipientsList.SegmentInputNamePlaceholder',
            })}
          />
        </FormElement>
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Cancel',
          })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="confirm"
          onClick={handleConfirm}
          disabled={!canSave}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSaveSegment
